import * as yup from 'yup';

const PHONE_NUMBER_TOO_SHORT = 'validations.phone-number-is-too-short';
const PHONE_NUMBER_OR_EMAIL_REQUIRED =
  'validations.phone-number-or-email-required';
const INVALID_PHONE_NUMBER = 'validations.invalid-phone-number';
const INVALID_DATE_OF_BIRTH = 'validations.date';

function basicInfoValidation(clientSettings, isNewClient = false) {
  let phoneNumber = yup
    .number()
    .integer()
    .min(100000000, PHONE_NUMBER_TOO_SHORT)
    .typeError(INVALID_PHONE_NUMBER);

  let email = yup.string().email();

  if (isNewClient) {
    // "required()" rules/constrains apply only to new clients
    // the required data can be removed when editing

    if (clientSettings.requiresMobileOrEmail) {
      phoneNumber = phoneNumber.when('email', {
        is: (emailValue) => !emailValue,
        then: phoneNumber.required(PHONE_NUMBER_OR_EMAIL_REQUIRED),
      });
      email = email.when('phoneNumber', {
        is: (phoneNumberValue) => !phoneNumberValue,
        then: email.required(PHONE_NUMBER_OR_EMAIL_REQUIRED),
      });
    } else {
      if (clientSettings.requiresMobile) phoneNumber = phoneNumber.required();
      if (clientSettings.requiresEmail) email = email.required();
    }
  }

  return {
    firstName: yup.string().min(1).max(32).required(),
    lastName: yup.string().min(1).max(32).required(),
    phoneNumber,
    email,
  };
}

export function getBasicInfoClientValidationSchema(
  clientSettings,
  isNewClient
) {
  return basicInfoValidation(clientSettings, isNewClient);
}

export function getClientOverviewValidationSchema(
  clientSettings,
  postSubmitValidations = {},
  isNewClient
) {
  let { firstName, lastName, phoneNumber, email } = basicInfoValidation(
    clientSettings,
    isNewClient
  );

  if (postSubmitValidations.phoneNumber) {
    phoneNumber = phoneNumber.test(
      postSubmitValidations.phoneNumber.name,
      postSubmitValidations.phoneNumber.message,
      (value) => value === postSubmitValidations.phoneNumber.value
    );
  }

  let schema = yup.object().shape(
    {
      firstName,
      lastName,
      phoneNumber,
      email,
      dateOfBirth: yup
        .date()
        .iso()
        .min(new Date('1900-01-01'), INVALID_DATE_OF_BIRTH)
        .max(new Date(), INVALID_DATE_OF_BIRTH)
        .typeError(INVALID_DATE_OF_BIRTH),
    },
    ['phoneNumber', 'email']
  );
  if (postSubmitValidations.treatCardSerial) {
    let schemaWithTreatCardValidation = yup.object().shape({
      serial: yup
        .string()
        .test(
          'duplicate-treatcard-serial',
          postSubmitValidations.treatCardSerial.message,
          () => false
        ),
    });
    return schema.concat(schemaWithTreatCardValidation);
  }

  return schema;
}
